import React from 'react';
import { connect } from 'react-redux';
import app, {
    EVENT_DEVICE_TYPE_CHANGED,
} from 'general/js/app';
import eventBus from 'general/js/event-bus';
import {
    LiveArrowControl,
    controlTypes,
    modeTypes,
} from 'components/live-arrow-control';
import { getComponentVisibility } from '../helpers/toch-helpers';
import OfferListCarousel from './offer-list-carousel';

class OfferList extends React.Component {
    constructor(props) {
        super(props);
        this.gallery = null;

        this.state = {
            deviceType: app.deviceTypeByViewport
        };

    }

    componentDidMount() {
        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    componentWillUnmount() {
        eventBus.removeListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    onDeviceTypeChanged = (oldDeviceType, newDeviceType) => {
        this.setState({
            deviceType: newDeviceType
        });
    }

    onClickPrevBtn = () => {
        this.gallery.goTo('prev');
    }

    onClickNextBtn = () => {
        this.gallery.goTo('next');
    }

    getNode = (node) => {
        this.gallery = node;
    }

    shouldRenderCarousel(offers) {
        if (offers === null) return false;

        return offers.length > 1;
    }


    render() {
        const {
            componentTitle,
            offers,
            defaultImage,
            componentVisibility
        } = this.props.data;

        const hasCarousel = this.shouldRenderCarousel(offers);
        const isVisible = getComponentVisibility(componentVisibility);

        return (
            isVisible &&
            (offers !== null && offers !== undefined) &&
            <div className='offer-list__wrap'>
                <div className='offer-list__container container'>
                    <div className='offer-list__content '>

                        <h3 className='offer-list__heading'>
                            <span className='offer-list__title'>{componentTitle}</span>
                        </h3>
                        <div className='offer-list__buttons-wrapper-top'>
                            {
                                hasCarousel &&
                                <div className='offer-list__buttons'>
                                    <LiveArrowControl
                                        mode={modeTypes.carousel}
                                        type={controlTypes.prev}
                                        onClickPrevBtn={this.onClickPrevBtn}
                                    />
                                    <LiveArrowControl
                                        mode={modeTypes.carousel}
                                        type={controlTypes.next}
                                        onClickNextBtn={this.onClickNextBtn}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                    <div className='offer-list__carousel'>
                        <div className='offer-list__carousel--container'>
                            <OfferListCarousel offers={offers} getNode={this.getNode} hasCarousel={hasCarousel} defaultImage={defaultImage} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const OfferListContainer = connect(
)(OfferList);

export default OfferListContainer;
